<template>
    <div class="get-info-container">
      <div class="get-info-content-header">
        <p style="height: 30px;" v-if="channel == 'fh'"></p>
        <img src="//assets/img/logo_l.png" alt="logo" v-else>
        <p class="header-successed-title">PMCore<span v-if="channel != 'fh'">广联达</span>云项目管理解决方案</p>
        <p class="header-successed-title">免费体验</p>
        <p class="header-content margin-top-6">您好，体验申请提交成功，工作人员将在48小时内与您联系，请保持电话畅通。</p>
        <p class="header-content">如有问题请扫码联系我们，</p>
        <p class="header-content">或致电：010-56403178</p>
      </div>
      <img src="//assets/img/wx1.png" alt="二维码" class="get-info-successed-wx">
    </div>
  </template>
  
  <script>
  export default {
    name: 'GetInfoSuccessed',
    props: {
      channel: {
        type: String
      },
    },
    data () {
      return {
      }
    },
    methods: {
    },
    mounted() {
      // alert(document.querySelector('#app').offsetWidth)
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .get-info-container {
      width: 400px;
      /* height: 1000px; */
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.32rem;
      padding: 0.2rem 0.5rem;
      border: 1px solid #ccc;
      background-color: #FFFFFF;
      border-radius: 0.08rem;
    }
    .get-info-content-header {
      margin-bottom: 0.2rem;
    }
    .get-info-content-header img {
      display: block;
      max-width: 3.2rem;
      margin: 0.4rem 0;
    }
    .header-successed-title {
      width: 100%;
      font-weight: 600;
      font-size: 0.45rem;
      text-align: center;
      margin: 0.1rem 0;
    }
    .header-content {
      width: 100%;
      color: #666;
      text-align: left;
      margin-top: 0.3rem;
    }
    .margin-top-6 {
      margin-top: 0.6rem;
    }
    .get-info-successed-wx {
      margin: 0.2rem 0 0.5rem 0;
      width: 5rem;
    }
  </style>
  